// extracted by mini-css-extract-plugin
export var paragraphBlock = "kC1hs";